import { useTranslation } from 'react-i18next';
import { DevBanner, Typography } from 'app/components';

import './TaxonomyHeader.scss';

interface TaxonomyHeaderProps {
  onLoadTaxonomies?: () => void;
}

export const TaxonomyHeader = ({ onLoadTaxonomies }: TaxonomyHeaderProps) => {
  const { t } = useTranslation('tag');

  return (
    <header className="taxonomy-header__wrapper">
      <Typography variant="body-8" fontWeight="semibold">
        {t('project.tax.label')}
      </Typography>

      <div className="taxonomy-header__btns">
        <button className="custom-btn" onClick={onLoadTaxonomies}>
          {t('load.taxonomies')}
        </button>

        <button className="custom-btn">
          {t('import.taxonomy')}
          <DevBanner />
        </button>
      </div>
    </header>
  );
};
